import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children: string | number | undefined | string[] | JSX.Element | null
  className: string
}

const Text = ({ children, className, ...other }: Props): JSX.Element => {
  return (
    <div className={`${className} text-component`} {...other}>
      {children}
    </div>
  )
}

export default Text
